// extracted by mini-css-extract-plugin
export default {"nextButton":"QuestionSubmitButton_nextButton__9Y5E5","is-question-list-button":"QuestionSubmitButton_is-question-list-button__KQx80"};